<div>
  @if (addressTypeControl) {
  <nz-form-item>
    <nz-form-label translate>{{ addressTypeLabel }}</nz-form-label>
    <nz-form-control>
      <nz-select
        nzSize="large"
        nzShowSearch
        l10n-placeholder
        [nzPlaceHolder]="addressTypePlaceholder | translate: locale.language"
        [formControl]="addressTypeControl"
      >
        @for (addressType of addressTypes$ | async; track addressType.id) {
        <nz-option [nzValue]="addressType.id" [nzLabel]="addressType.label"></nz-option>
        }
      </nz-select>
    </nz-form-control>
  </nz-form-item>
  } @if (countryControl) {
  <nz-form-item>
    <nz-form-label translate>{{ countryLabel }}</nz-form-label>
    <nz-form-control>
      <nz-select
        nzSize="large"
        nzShowSearch
        l10n-placeholder
        [maxlength]="config.addressCountryMaxLength"
        [nzPlaceHolder]="countryPlaceholder | translate: locale.language"
        [formControl]="countryControl"
        [nzFilterOption]="diacriticInsensitiveFilter"
        data-cy="address-country-select"
      >
        @for (country of countries$ | async; track country.id) {
        <nz-option [nzLabel]="country.label" [nzValue]="country.id"></nz-option>
        }
      </nz-select>
    </nz-form-control>
  </nz-form-item>
  } @if (provinceControl) {
  <nz-form-item>
    <nz-form-label translate>{{ provinceLabel }}</nz-form-label>
    <nz-form-control>
      <input
        nz-input
        nzSize="large"
        type="text"
        [maxlength]="provinceMaxLength || config.identificationProvinceOfBirthMaxLength"
        [placeholder]="provincePlaceholder | translate: locale.language"
        [formControl]="provinceControl"
        data-cy="address-province-input"
      />
    </nz-form-control>
  </nz-form-item>
  } @if (cityControl) {
  <nz-form-item>
    <nz-form-label translate>{{ cityLabel }}</nz-form-label>
    <nz-form-control>
      <input
        nz-input
        nzSize="large"
        type="text"
        [maxlength]="cityMaxLength || config.identificationCityOfBirthMaxLength"
        [placeholder]="cityPlaceholder | translate: locale.language"
        [formControl]="cityControl"
        data-cy="address-city-input"
      />
    </nz-form-control>
  </nz-form-item>
  } @if (streetControl) {
  <nz-form-item>
    <nz-form-label translate>{{ streetLabel }}</nz-form-label>
    <nz-form-control>
      <input
        nz-input
        nzSize="large"
        type="text"
        [maxlength]="streetMaxLength"
        [placeholder]="streetPlaceholder | translate: locale.language"
        [formControl]="streetControl"
        data-cy="address-street-input"
      />
    </nz-form-control>
  </nz-form-item>
  } @if (buildingNameControl) {
  <nz-form-item>
    <nz-form-label translate>{{ buildingNameLabel }}</nz-form-label>
    <nz-form-control>
      <input
        nz-input
        nzSize="large"
        type="text"
        [maxlength]="buildingNameMaxLength"
        [placeholder]="buildingNamePlaceholder | translate: locale.language"
        [formControl]="buildingNameControl"
        data-cy="address-building-name-input"
      />
    </nz-form-control>
  </nz-form-item>
  } @if (buildingNumberControl) {
  <nz-form-item>
    <nz-form-label translate>{{ buildingNumberLabel }}</nz-form-label>
    <nz-form-control>
      <input
        nz-input
        nzSize="large"
        type="text"
        [maxlength]="buildingNumberMaxLength"
        [placeholder]="buildingNumberPlaceholder | translate: locale.language"
        [formControl]="buildingNumberControl"
        data-cy="address-building-number-input"
      />
    </nz-form-control>
  </nz-form-item>
  } @if (postalCodeControl) {
  <nz-form-item>
    <nz-form-label [ngClass]="{ 'app-postal-code-label-with-info': showPostalCodeRequiredInfoIcon }">
      {{ postalCodeLabel | translate: locale.language }} @if (showPostalCodeRequiredMark) {
      <span class="app-postal-code-required-mark">*</span>
      } @if (showPostalCodeRequiredInfo) {
      <app-icon-with-popover [icon]="'info-circle'" [popoverContent]="'payment.receiverInfo.address.postalCode.noPostalCodeInfo'"></app-icon-with-popover>
      }
    </nz-form-label>
    <nz-form-control>
      <input
        nz-input
        nzSize="large"
        type="text"
        [maxlength]="postalCodeMaxLength || config.beneficiaryPostalCodeMaxLength"
        [placeholder]="postalCodePlaceholder | translate: locale.language"
        [formControl]="postalCodeControl"
        data-cy="address-postal-code-input"
      />
    </nz-form-control>
  </nz-form-item>
  } @if (addressControl) {
  <nz-form-item>
    <nz-form-label translate>{{ addressLabel }}</nz-form-label>
    <nz-form-control>
      <input
        nz-input
        nzSize="large"
        type="text"
        [maxlength]="config.beneficiaryBankAddressMaxLength"
        [placeholder]="addressPlaceholder | translate: locale.language"
        [formControl]="addressControl"
        data-cy="address-address-input"
      />
    </nz-form-control>
  </nz-form-item>
  }
</div>
